<template>
    <div>
        <v-menu offset-y>

            <v-btn small color="black" icon slot="activator">
                <v-icon small color="white">file_download</v-icon>
            </v-btn>
            
            <v-list class="py-3">

                <v-list-tile :key="`labels${varid}`">
                    <v-list-tile-content>
                        <labels :item="itemsFromIds" small light></labels>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :key="`labelsSmall${varid}`">
                    <v-list-tile-content>
                        <labels-small :item="itemsFromIds" small light></labels-small>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :key="`labelsSmallText${varid}`">
                    <v-list-tile-content>
                        <labels-small-text :item="itemsFromIds" small light></labels-small-text>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :key="`excel${varid}`">
                    <v-list-tile-content>
                        <excel :data="itemsFromObjects" small light :name="`Current Selection List of ${itemsFromObjects.length}`" fileName="current_selection_list"></excel>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>
        </v-menu>

    </div>
</template>

<script>
import Labels from "../lists/Labels";
import LabelsSmall from "../lists/LabelsSmall";
import LabelsSmallText from "../lists/LabelsSmallText";
import Excel from "@/components/artworks/Excel";

export default {
    props: {
      light: Boolean,
      small: Boolean,
      item: Object,
      ids: Boolean,
      useCurrentSelection: Boolean
    },
    data: () => ({
    }),
    computed: {
        varid() { 
            if (!isNaN(this.item)) {
                return  this.item
            } else if (typeof this.item === 'object') {
                return this.item.id
            } else {
                return 'a'
            }
        },
        // labelId() { 
        //     return `label${id}`
        // }
        itemsFromObjects() {
            // console.log('itemsFromObjects111')
            // console.log(this.useCurrentSelection)
            // console.log(this.small)
            // console.log(this.ids)
            // console.log(this.item)
            // console.log(this.$store.state.currentSelection)
            var item = []
            // item.artworks = []
            if (this.useCurrentSelection) {
                item = this.$store.state.currentSelection
                // item.artworks = this.ids2o(this.item)
            } else {
                if (this.ids) {
                    if (this.item.artworks) {
                        item = this.ids2o(this.item.artworks)
                    // } else {
                    // item = this.item.map(i => i.id)
                    } else {
                        console.error('no data in itemsFromObjects item prop')
                    }
                } else {
                    if (isNaN(this.item.artworks[0])) {
                        item = this.item.artworks
                    } else {
                        item = this.ids2o(this.item.artworks)
                        // console.error('no data in itemsFromObjects item prop')
                    }
                }
            }
            // console.log(item)
            // console.log('itemsFromObjects2223s')
            return item
        },
        itemsFromIds() {
            // console.log('itemsFromIds112')
            // console.log(this.useCurrentSelection)
            // console.log(this.small)
            // console.log(this.ids)
            // console.log(this.item)
            // console.log(this.$store.state.currentSelection)
            var item = {}
            item.artworks = []
            if (this.useCurrentSelection) {
                item.artworks = this.ids2o(this.$store.state.currentSelection)
                // item.artworks = this.ids2o(this.item)
            } else {
                if (this.ids) {
                    if (this.item.artworks) {
                        item = this.item
                        } else {
                        item.artworks = this.item.map(i => i.id)
                    }
                } else {
                    item = this.item
                }
            }
            // console.log(item)
            // console.log('itemsFromIds2')
            return item
        }
    },
    components: {
        LabelsSmallText, Labels, LabelsSmall, Excel
    }     
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/ListActionMenu.vue